import _ from "lodash";
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import SimpleHeader from "../../components/layout/SimpleHeader";
import TabItem from "../../components/statistics/placement-test/TabItem";
import PtStatsByExam from "../../components/statistics/placement-test/PtStatsByExam";
import PtStatsByGradeDetail from "../../components/statistics/placement-test/PtStatsByGradeDetail";
import PtStatsByStudentsDetail from "../../components/statistics/placement-test/PtStatsByStudentsDetail";

export enum ETapStatus {
  BASIC = "B",
  GRADE = "G",
  STUDENTS = "S"
}

const StatisticsPlacementTest = () => {
  
  const { t } = useTranslation();
  const [tabStatus, setTabStatus] = useState('B'); //B : 종합, G: 학년별, S : 학생상세

  const renderContent = () => {
    switch (tabStatus) {
      case ETapStatus.BASIC:
        return <PtStatsByExam />;
      case ETapStatus.GRADE:
        return <PtStatsByGradeDetail />;
      case ETapStatus.STUDENTS:
        return <PtStatsByStudentsDetail />;
      default:
        return <PtStatsByExam />;
    }
  }
  
  return (
    <>
    <SimpleHeader
      iconFile="icon-statistics-big.svg"
      parentMenu={t('common.menu.statistics')}
      currentMenu={t('statistics.placementTest.title1')}
      onlyTitle={true}
    />
    <div className="content scrollbar">
      {/* tab 영역 */}
      <div className="col-frame">
        <div className="comm-tab__line">
          <ul>
            <TabItem
              currentContent={tabStatus}
              onSetContent={setTabStatus}
              tabContent={ETapStatus.BASIC}
              tabLabel={t('entrance.schedule.tab1')}
            />
            <TabItem
              currentContent={tabStatus}
              onSetContent={setTabStatus}
              tabContent={ETapStatus.GRADE}
              tabLabel={t('entrance.schedule.tab2')}
            />
            <TabItem
              currentContent={tabStatus}
              onSetContent={setTabStatus}
              tabContent={ETapStatus.STUDENTS}
              tabLabel={t('entrance.schedule.tab3')}
            />
          </ul>
        </div>
        <div>
          {/* contents 영역 */}
          {renderContent()}
        </div>
        </div>
    </div>
    </>
  );
}

export default StatisticsPlacementTest;
